import Vue from "vue";
import axios from "axios";
import axios2 from "axios";
import VueAxios from "vue-axios";

const API_URL = process.env.VUE_APP_API_ROOT || "/api/v1";
const API_URL2 = process.env.VUE_APP_API_BASE || "/api/v1";

const plainAxiosInstance = axios.create({
  // baseURL: API_URL,
  baseURL: API_URL2,
  // timeout: 1000, // ! not good for solution request
  // withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

plainAxiosInstance.interceptors.request.use(
  (config) => {
    if (!config.url.includes('/sso')){
      if (!config.url.includes('auth/')){
        if (!config.url.includes('/v2')){
          let url = `api/v1${config.url}`
          config.url = url
        }
      }
    }   


    // sequencia para trocar os tokens 1x ao dia
    if (!config.url.includes('auth/validate_token') && !Object.keys(config.headers).includes('authorization')){
      // se nao for validate-token e nao ter headers de ghost, nao troca
      config.headers = {
        ...config.headers,
        'mobile-client': true // faz nao trocar
      }
    } else if (config.url.includes('auth/validate_token')) {
      // se for validate-token, faz analise
      // se ja setou o time que fez a primeira vez ckb_last_changed_tk_at_sec
        // checa se tem menos de 24h desde a ultima checagem (now - last_changed < 24)
          // se menor, nao troca
          // se maior, seta novo ckb_last_changed_tk_at_sec e nao envia mobile-client
      // se nao
        // seta novo ckb_last_changed_tk_at_sec
        
      if (localStorage.ckb_last_changed_tk_at_sec){
        let now = new Date().getTime()/1000
        let diff = (now - localStorage.ckb_last_changed_tk_at_sec) / (60*60)
        console.warn('diff:', diff);
        if (diff < 24){
          
          config.headers = {
            ...config.headers,
            'mobile-client': true // faz nao trocar
          }
        } else {
          localStorage.ckb_last_changed_tk_at_sec = new Date().getTime()/1000
        }
      } else{
        localStorage.ckb_last_changed_tk_at_sec = new Date().getTime()/1000
      } 
    }


    // Authorization: Bearer a37f1bb50789c7963c1a8567
    // GHOST stuff
    // console.log("##################");
    // console.log(Object.keys(config.headers));
    // console.log("##################");
    
    if (Object.keys(config.headers).includes('authorization')){
      // console.log('#####');
      // console.log(config.headers.authorization);
      config.headers = {
        ...config.headers,
        "authorization": (config.headers.authorization == 'true' && localStorage.ghost_tk) || config.headers.authorization
      }
    } else {

    }
    return config;
  },
  (error) => {
    alert("Ops! Algo errado com a requisição.");
    console.log(error);
    return Promise.reject(error);
  }
);

plainAxiosInstance.interceptors.response.use(
  function(response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    // auto-comment// 
    // console.log({response});
    if (response.status >= 200 && response.status< 300){
      if (response.config.url.includes("api/v1/ghost_executions")){
        if (response.config.method == 'put' && ['concluded', 'to_approve', 'to_review'].includes(response.data.data.attributes.state) ){
          // console.log('VAAII REMOVERO GHOST-TK')
          localStorage.removeItem('ghost_tk');
        }
      }
    }
    // console.log({tk: localStorage.auth_token_default})
    if (response.headers["access-token"]) {
      
    }
    return response;
  },
  function(error) {
    // console.log({error})
    // store.dispatch('Notification/add', {type: 'error', msg: 'houve um erro'})
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error

    if (error.response && !error.response.headers["access-token"]){
      console.log('dont have access token');
      // make request to renovate and validate token
      // ProposalApi.index()
    }
    
    return Promise.reject(error);
  }
);

Vue.use(VueAxios, {axios: plainAxiosInstance, outros: axios2});
// Vue.use(VueAxios, plainAxiosInstance);

export default plainAxiosInstance;
// export default { securedAxiosInstance, plainAxiosInstance }
